export default __webpack_public_path__ + "static/media/girl.0c6ff244.webp";